import type { PresentationModule } from '../../presentation/types';
import { climateViewPoint } from './content';
import { ClimateViewPointScene } from './scenes/ClimateViewPointScene';

export const climateViewPointModule: PresentationModule = {
  id: 'climateviewpoint',
  label: 'ClimateViewPoint',
  priority: 'standard',
  scenes: [
    { ...climateViewPoint, module: 'climateviewpoint', create: (resolved) => new ClimateViewPointScene(resolved) },
  ],
};
